import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Button } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

interface ChatActionNextProps extends PropsWithChildren {
  formId?: string;
  disabled?: boolean;
  loading?: boolean;

  onClick?: () => void;
}

export const ChatActionNext: React.FC<ChatActionNextProps> = ({ children, formId, disabled, loading, onClick }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'ChatActionNext' });
  return (
    <Button
      variant="contained"
      color="primary"
      endIcon={<ArrowDownwardIcon />}
      type={formId ? 'submit' : 'button'}
      form={formId}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    >
      {children ?? t('title')}
    </Button>
  );
};
